import { Component, ElementRef } from '@angular/core';
import { AppService } from './services/app.service';
import { NavigationEnd, NavigationStart, Router,Event as NavigationEvent } from '@angular/router';
import { GtagService } from './services/gtag.service';
import { filter } from 'rxjs/operators';
import { DataService } from './services/data.service'; 

declare var $:any;
declare var urlMetrix:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  public ativo          = null;
  public configuracao   = null;  

  constructor(
    private app: AppService,
    private router: Router,
    private gtag: GtagService,
    private data: DataService,
    private elementRef:ElementRef
  ){

    this.onEvents(); 
    
    let ativo           = this.elementRef.nativeElement.getAttribute('ativo') ? this.elementRef.nativeElement.getAttribute('ativo').toString() : true; 
    this.configuracao   = this.elementRef.nativeElement.getAttribute('configuracao') ? JSON.parse(this.elementRef.nativeElement.getAttribute('configuracao').toString()) : null;
  
    if(ativo === true || ativo === "true"){
      this.ativo = true;  
    }else{
      this.ativo = false;
    }

    if(typeof(urlMetrix) != "undefined"){
      this.sendMetrix(urlMetrix);
    }

  }
  /** 
   * 
   * On Events
   * 
   */
  onEvents(){

    this.router.events.forEach((event: NavigationEvent) => {
      
      if(event instanceof NavigationStart){
        
      }
      
      if(event instanceof NavigationEnd) {

        setTimeout(()=>{
          
        },200)

      }

    });
    this.app.emitChangePage.subscribe(response => {
      
    });
    this.app.setStatusServidorEmitter.subscribe(code => {
      //this.statusCode = code;
    });
    const navEndEvents = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );
    navEndEvents.subscribe((event: NavigationEnd) => {
      
      setTimeout(() => { 
        this.gtag.sendPagePath(event.urlAfterRedirects); 
      },1000);

    }); 


  }
  /**
   * 
   * @param url 
   * 
   */
   sendMetrix(url){
  
    $.getJSON(url,function(data){});
 
  }


}
